<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="mini"
    :color="returnColor()"
    absolute
    class="custom-scrollbar mt-12"
    expand-on-hover
    floating
    dark
    dense
    permanent
  >
    <!-- expand-on-hover -->
    <div class="">
      <v-list nav dense>
        <!-- <v-list-group
          v-for="item in items"
          :key="item.title"
          :prepend-icon="item.icon"
          active-class="border"
          color="white"
          no-action
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>

          <v-list-item
            link
            v-for="child in item.items"
            :key="child.title"
            :to="child.path"
            hover-class="border-left"
            @click="getSubmenu(child.title, child.path)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group> -->
        <v-list-item
          link
          to="/home"
          active-class="border"
          color="white"
          hover-class="border-left"
          @click="getSubmenu('Dashboard', '/home')"
        >
          <v-list-item-icon title="Dashboard">
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          to="/CustomerList"
          active-class="border"
          color="white"
          hover-class="border-left"
          @click="getSubmenu('Send Transaction', '/CustomerList')"
        >
          <v-list-item-icon title="Send Transaction">
            <icon name="send txn" bordColor="white" size="large" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Send Transaction</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          v-for="item in items"
          :key="item.title"
          :to="item.path"
          active-class="border"
          color="white"
          hover-class="border-left"
          @click="getSubmenu(item.title, item.path)"
        >
          <v-list-item-icon :title="item.title">
            <icon :name="item.icon" bordColor="white" :size="item.size" />
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <!-- <template v-slot:append>
      <v-list-item @click="mini = true" v-if="!mini" dense>
        <v-list-item-icon>
          <v-icon>mdi-chevron-triple-left</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-subtitle>Collapse Sidebar</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="mini = false" v-else dense>
        <v-list-item-icon>
          <v-icon>mdi-chevron-triple-right</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-subtitle>Collapse Sidebar</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template> -->
  </v-navigation-drawer>
</template>

<script>
const pjson = require("../../../package.json");
import icon from "../../assets/icons/icons.vue";
export default {
  name: "SideNavigation",
  props: {
    isMenuMinimized: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    icon,
  },
  data: () => {
    return {
      appVersion: pjson.version,
      drawer: true,

      items: [
        // {
        //   title: "Send Transaction",
        //   icon: "send txn",
        //   path: "/CustomerList",
        // },
        {
          title: "Hold Transactions",
          icon: "mdi-text-box-check",
          path: "/TransHoldpage",
        },
        {
          title: "Calculator",
          icon: "mdi-calculator",
          path: "/transactionCalc",
        },
        {
          title: "Search Transaction",
          icon: "mdi-text-box-search",
          path: "/searchTxn",
        },
        // {
        //   title: "Transaction",
        //   icon: "mdi-bank",
        //   items: [
        //     { title: "Calculator", path: "/transactionCalc" },
        //     { title: "Send Transaction", path: "/CustomerList" },
        //     { title: "Hold Transactions", path: "/TransHoldpage" },
        //     { title: "Search Transaction", path: "/searchTxn" },
        //   ],
        // },
        // {
        //   title: "Manage Customer",
        //   icon: "mdi-account-group-outline",
        //   items: [{ title: "Customer Search", path: "/CustomerSummary" }],
        // },
      ],
      mini: true,
      isMobileBreakPoint: window.innerWidth < 720,
    };
  },
  created() {
    let routeData = this.$route;
    //to call getsubmenu if user refresh the page
    if (routeData.path && routeData.path != "/home") {
      this.items.map((ele) => {
        ele.items.map((sub) => {
          if (sub.path === routeData.path) {
            this.getSubmenu(sub.title, sub.path);
          }
        });
      });
    }
  },
  watch: {
    mini(newVal) {
      this.$emit("minimizeMenu", newVal);
    },
    isMenuMinimized(newVal) {
      console.log(newVal);
      this.mini = newVal;
    },
  },
  methods: {
    returnColor() {
      return `#${process.env.VUE_APP_COLOR}`;
    },
    //to emit selected tab to layout page
    getSubmenu(title, path) {
      console.log("title: ", title, "path :", path);
      this.$emit("slectedTab", { title: title, path: path, close: true });
    },

    minimizeMenu() {
      this.$emit("minimizeMenu", true);
      this.mini = !this.mini;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
::v-deep ::-webkit-scrollbar {
  width: 0;
  background: transparent;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px;
}
.v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}
.my-icon {
  padding: 0 !important;
  margin: 0 !important;
  /* font-size: 24px !important; */
}

.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 50px;
}
.v-application a {
  text-decoration: none !important;
}
// .active-col {
//   color: white;
// }
</style>
